import UpdateMaps from "@/components/Elemnt/Maps/UpdateMaps";
import { useParams } from "react-router";

const UpdatePage = () => {
  const { appToken = "" } = useParams();
  return <UpdateMaps appToken={appToken} />;
};

export default UpdatePage;
